import type { Lead } from './types'
export interface EnquiryRegularChoice { offer_id: number; offer_version?: number; days: number | null; pence: number; first: number; choice: string }
export function regularChoiceOn(lead: Pick<Lead, 'regular_choice_json' | 'regular_offers_enabled'>): EnquiryRegularChoice | null {
  if (!lead.regular_offers_enabled) return null
  try {
    const p = JSON.parse(lead.regular_choice_json ?? 'null') as EnquiryRegularChoice | null
    return p && Number.isInteger(p.offer_id) && Number.isInteger(p.pence) && Number.isInteger(p.first) && (p.days === null || Number.isInteger(p.days) && p.days > 0) ? p : null
  } catch { return null }
}
export const regularChoiceWords = (days: number | null): string => days ? `every ${days / 7} weeks` : 'just occasionally'
